import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { ADELPHI_CASKS_DEFAULT_STATE } from './constants';

const completedState = completeState(ADELPHI_CASKS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.GET_ALL_CASK_FILLINGS,
    actions.CREATE_ADELPHI_CASKS_OF_EXCEL,
    actions.GET_CASK_FILLING_BY_ID
  ],
  override: {
    [actions.SET_CURRENT_ADELPHI_CASK_FILLING]: onReadValue()
  }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
